const authenticated_es = require('./authenticated.json')
export default authenticated_es